import { render } from "./ProfileSelecting.vue?vue&type=template&id=0ae97092"
import script from "./ProfileSelecting.vue?vue&type=script&lang=js"
export * from "./ProfileSelecting.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__